import dynamic from 'next/dynamic';
import {
  initializeBuilderIOKit,
  fetchSection,
  FetchEntryOptions,
} from '@zapier/builder-io-kit-compat';
import * as Sentry from '@sentry/nextjs';

import { config as AvatarBuilderConfig } from './components/avatar';
import { config as ButtonBuilderConfig } from './components/button';
import { config as FeatureItemListBuilderConfig } from './components/feature-item-list';
import { config as FeatureItemBuilderConfig } from './components/feature-item';
import { config as ServiceIconBuilderConfig } from './components/service-icon';

export function init() {
  initializeBuilderIOKit({
    coreComponentsLoader: (componentName: string) =>
      dynamic(() =>
        import('@zapier/builder-io-kit-compat').then(
          (mod: Record<string, any>) => mod?.[componentName]
        )
      ),
    customComponents: [
      AvatarBuilderConfig,
      ButtonBuilderConfig,
      FeatureItemBuilderConfig,
      FeatureItemListBuilderConfig,
      ServiceIconBuilderConfig,
    ],
    Sentry,
  });
}

export function safelyFetchSection(options: FetchEntryOptions) {
  return fetchSection(options)
    .then(response => {
      // TEMP: Builder Kit will currently always return an object even if no content was found.
      return response?.data ? response : null;
    })
    .catch(error => {
      console.error('Error fetching sign up section from Builder.io', error);
      return null;
    });
}
